<!--
Component that indicates a single sales contact to log in as.
When clicked, hooks the user up as that sales contact.
-->
<template>
	<button
		type="button"
		@click="onClick"
		:disabled="loading"
		class="group hover:bg-background-25 grid w-full grid-cols-[1fr_40px] grid-rows-[20px_17px] content-stretch justify-stretch gap-x-4 gap-y-1 p-3"
		:class="[loading && 'cursor-wait']"
	>
		<div class="text-primary-700 col-start-1 text-left font-bold">
			{{ firstname }} {{ lastname }}
		</div>
		<div
			class="text-secondary-900 col-start-1 row-start-2 text-left text-sm font-normal"
		>
			{{ email }}
		</div>

		<!-- Icon -->
		<div class="col-start-2 row-span-2 size-5 place-self-center">
			<img
				v-if="loading"
				:src="spinner"
				class="size-5 animate-spin"
			/>
			<ArrowLongRightIcon
				v-else
				class="text-accent-600 size-5 -translate-x-5 transition-transform ease-in group-hover:translate-x-0"
			/>
		</div>
	</button>
</template>

<script setup lang="ts">
import spinner from '@/assets/spinner.svg'
import { useAuthStore } from '@/stores/auth'
import { ArrowLongRightIcon } from '@heroicons/vue/24/solid'
import { ref } from 'vue'

const props = defineProps({
	id: String,
	firstname: String,
	lastname: String,
	email: String,
})

const loading = ref(false)

/** Handle click: log in as this sales contact */
function onClick() {
	if (!props.id)
		throw new Error(
			'Clicked on a SalesContactListItem with no contact passed in'
		)

	loading.value = true
	useAuthStore().viewAppAsSalesContact(props.id)
}
</script>
